(function (){
    'use strict';

    angular
        .module('app')
        .directive('nickValidate', nickValidate);

    nickValidate.$inject = ['FindClientsService'];

    function nickValidate(FindClientsService) {
       return {
           restrict:'A',
          // templateUrl: 'templates/directives/validate/nickTemplate.html',
           require:'ngModel',
           scope:{
               cod: '='
           },
           link:link,

       }


        function link(scope, element, attrs, ctrl) {

            element.bind("focus", function(){
            var validator = function(value) {

                var regExp = /([+,!@#$?=%^&*();\/|<>"'\s])+?$/g;

                var service = [];
                var serviceCod = [];


                FindClientsService.getByName(ctrl.$viewValue).then(function (response) {
                    service = response.data;

                    if (regExp.test(ctrl.$viewValue)) {
                        ctrl.$setValidity('emailValidate', false);
                        angular.element(element.parent().removeClass('has-error'));
                        angular.element(element.parent().find("span").remove());
                        angular.element(element.parent().addClass('has-error'));
                        angular.element(element.parent().append("<span class='help-block'>You have entered an invalid character. Use ONLY letters and numbers. Do NOT use spaces.</span>"));
                    } else {
                        ctrl.$setValidity('emailValidate', true);
                        angular.element(element.parent().removeClass('has-error'));
                        angular.element(element.parent().find("span").remove());
                    }
                    ctrl.$setViewValue(ctrl.$viewValue);
                    ctrl.$render();

                    // serviceCod = ;

                    if (typeof service[0] !== 'undefined') {
                        serviceCod = service[0].id ;
                        if (serviceCod != scope.cod) {
                            ctrl.$setValidity('emailValidate', false);
                            angular.element(element.parent().addClass('has-error'));
                            angular.element(element.parent().append("<span class='help-block'>This nick already being used.</span>"));
                        } else {
                            ctrl.$setValidity('emailValidate', true);
                            angular.element(element.parent().removeClass('has-error'));
                            angular.element(element.parent().find("span").remove());
                        }
                    }
                });
                return value;
            };
            ctrl.$parsers.unshift(validator);
            ctrl.$formatters.unshift(validator);

            });
        }
    }
})();